<template>
  <div class="stage stage-1">
    <div class="stage-header">
      <h3>01: SELECT USER</h3>
    </div>
    <div class="stage-body">
      <div class="pre-defined-users">
        <div class="users-holder">
          <div class="user create-user" @click="createUser = true">
            <p>CREATE NEW USER</p>
          </div>
          <div
            class="user"
            :class="{ selected: selectedUserId === user.id }"
            @click="selectUser(user)"
            v-for="user in users"
            :key="user.id"
          >
            <div class="user-top-row">
              <p>{{ calculateTimeago(user.last_post) }} <br> inactive</p>
              <div class="user-picture">
                <img
                  v-if="getUserPicture(user) !== ''"
                  :src="getUserPicture(user)"
                />
              </div>
              <div class="check-img">
                <img src="../../assets/check.png"/>
              </div>
            </div>
            <div class="user-name">
              {{ user.first_name }}
              {{ user.last_name }}
            </div>
            <div class="user-info">
              {{ user.location || '-' }}
            </div>
            <div class="user-info">
              {{ calculateAge(user.birthday) }} YEARS
            </div>
            <div class="user-info">
              {{ user.strength || '-'}} STRENGTH
            </div>
            <p class="user-bio-title">BIO:</p>
            <div class="user-bio">
              {{ user.bio }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en'

TimeAgo.addDefaultLocale(en);

export default {
  name: "UserDetails",

  methods: {
    getUserPicture(user) {
      if (user.image !== "" && user.image !== null) {
        if (user.image.indexOf('blob:') > -1) {
          return user.image;
        }

        let url = window.location.origin;
        if (url === "http://localhost:8080") {
          url = "http://localhost:3000";
        }
        return url + user.image;
      }
      return "";
    },

    calculateAge(birthday) {
      var ageDifMs = Date.now() - Date.parse(birthday);
      var ageDate = new Date(ageDifMs); // miliseconds from epoch

      return Math.abs(ageDate.getUTCFullYear() - 1970);
    },

    calculateTimeago(lastDate) {
      if (lastDate) {
        const date = new Date(lastDate.split(' +')[0]);
        const timeAgo = new TimeAgo('en-US')
        return timeAgo.format(date, 'mini');
      }
      return '-';
    },

    async selectUser(user) {
      if (this.selectedUserId === user.id) {
        this.selectedUserId = "";
        this.selectedUser = {};
        this.workouts = [];
      } else {
        this.selectedUserId = user.id;
        this.selectedUser = user;
        this.$store.dispatch('activity/loadPublicWorkouts', user.id);
      }
    },

  },

  computed: {
    createUser: {
      get () {
        return this.$store.state.activity.createUser
      },
      set (value) {
        this.$store.commit('activity/updateAttribute', {value: value, type: 'createUser'})
      }
    },

    selectedUser: {
      get () {
        return this.$store.state.activity.selectedUser
      },
      set (value) {
        this.$store.commit('activity/updateAttribute', {value: value, type: 'selectedUser'})
      }
    },

    selectedUserId: {
      get () {
        return this.$store.state.activity.selectedUserId
      },
      set (value) {
        this.$store.commit('activity/updateAttribute', {value: value, type: 'selectedUserId'})
      }
    },

    users() {
      return this.$store.state.activity.users;
    }
  }

}
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables";

.stage {
  width: 100%;
  padding-bottom: $spacing-base;

  .stage-header {
    padding: $spacing-base;
    display: flex;
    h3 {
      font-size: 14px;
      font-weight: 700;
      padding: 0;
      margin: 0;
      color: white;
    }
  }

  .stage-body {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding-left: $spacing-base;

    .pre-defined-users {
      .users-holder {
        display: flex;
        overflow-y: scroll;
        padding: $spacing-base;
        padding-top: 0;
        .selected {
          background: $blue !important;
          .user-top-row {
            p {
              color: #fff !important;
            }
          }
          .user-name {
            color: #fff !important;
          }
          .user-info {
            color: #fff !important;
          }
          .user-bio-title {
            color: #fff !important;
          }
          .user-bio {
            color: #fff !important;
          }
          .user-last-created {
            color: #fff !important;
          }
          .check-img {
            img {
              display: block !important;
            }
          }
        }
        .user {
          &:first-of-type {
            width: 120px;
            background: $sec1;

            p {
              text-align: center;
              font-size: 12px;
              font-weight: bold;
              margin: auto;
              color: $sec4;
            }
          }
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 240px;
          height: 280px;
          background: $sec0;
          cursor: pointer;
          margin-right: $spacing-base;
          border-radius: $border-radius;
          flex-shrink: 0;
          box-sizing: border-box;
          padding: 8px;

          .user-top-row {
            display: flex;
            width: 100%;

            p {
              flex: 1;
              text-align: left;
              margin: 0;
              color: $sec5;
              font-size: 12px;
              font-weight: 500;
              text-transform: uppercase;
            }

            .user-picture {
              background-image: url(~@/assets/default_picture.png);
              background-size: cover;
              margin-bottom: $spacing-small;
              border-radius: 80px;
              height: 80px;
              width: 80px;
              img {
                width: 80px;
                height: 80px;
                border-radius: 80px;
              }
            }

            .check-img {
              flex: 1;
              img {
                display: none;
                width: 28px;
                height: 28px;
                float: right;
              }
            }
          }

          .user-name {
            font-weight: bold;
            font-size: 18px;
            color: white;
            text-transform: uppercase;
            text-align: center;
          }
          .user-info {
            font-weight: 500;
            font-size: 12px;
            color: $sec5;
            text-transform: uppercase;
            text-align: center;
            margin-top: $spacing-small;
          }
          .user-bio-title {
            font-weight: 500;
            font-size: 12px;
            color: $sec5;
            margin: 0;
            margin-top: $spacing-small;
          }
          .user-bio {
            font-weight: normal;
            font-size: 12px;
            text-align: center;
            color: $sec5;
          }
          .user-last-created {
            font-weight: normal;
            font-size: 12px;
            text-align: center;
            color: $sec5;
          }
        }
      }
    }
  }
}
</style>